import Vue from 'vue'
import Vuex from 'vuex'
import axios from "axios";
//import Cookies from 'js-cookie'
Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        baseredirect: '/web',
        //baseredirect: ''
    },
    getters: {},
    mutations: {},
    actions: {},
    modules: {}
})